import { JSX } from "preact";
import { Section } from "./Section.tsx";

// Clean monochrome SVG line icons (Feather/Lucide style)
const ICON_PATHS: Record<string, JSX.Element> = {
  flame: <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />,
  lock: <>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </>,
  file: <>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <path d="M9 13h6" />
    <path d="M9 17h6" />
  </>,
  search: <>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.35-4.35" />
  </>,
  radio: <>
    <path d="M5 12.55a11 11 0 0 1 14.08 0" />
    <path d="M1.42 9a16 16 0 0 1 21.16 0" />
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
    <path d="M12 20h.01" />
  </>,
  trending: <>
    <path d="M23 6l-9.5 9.5-5-5L1 18" />
    <path d="M17 6h6v6" />
  </>,
  warning: <>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </>,
  monitor: <>
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
    <path d="M8 21h8" />
    <path d="M12 17v4" />
  </>,
  building: <>
    <path d="M3 21h18" />
    <path d="M5 21V7l8-4v18" />
    <path d="M19 21V11l-6-4" />
    <path d="M9 9v.01" />
    <path d="M9 12v.01" />
    <path d="M9 15v.01" />
    <path d="M9 18v.01" />
  </>,
  dollar: <>
    <path d="M12 1v22" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </>,
  shield: <>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </>,
  "graduation-cap": <>
    <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
    <path d="M6 12v5c0 1 2 3 6 3s6-2 6-3v-5" />
  </>,
  school: <>
    <path d="M12 3v18M3 21h18" />
    <path d="M5 21V10l7-4 7 4v11" />
  </>,
  landmark: <>
    <path d="M3 22h18" />
    <path d="M6 22V10" />
    <path d="M18 22V10" />
    <path d="M12 22V10" />
    <path d="M3 10l9-6 9 6" />
    <path d="M3 10h18" />
    <path d="M12 2v2" />
  </>,
  bank: <>
    <path d="M3 21h18" />
    <path d="M3 10h18" />
    <path d="M5 10V21" />
    <path d="M19 10V21" />
    <path d="M9 10V21" />
    <path d="M15 10V21" />
    <path d="M12 2L3 7l9 5 9-5z" />
  </>,
  "heart-pulse": <>
    <path d="M3 12h4l3 9 4-18 3 9h4" />
  </>,
  "check-circle": <>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <path d="M22 4L12 14.01l-3-3" />
  </>,
  phone: <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />,
  users: <>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </>,
  clock: <>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </>,
  headphones: <>
    <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
  </>,
  message: <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />,
  server: <>
    <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
    <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
    <path d="M6 6h.01" />
    <path d="M6 18h.01" />
  </>,
  cloud: <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />,
  settings: <>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </>,
  refresh: <>
    <path d="M23 4v6h-6" />
    <path d="M1 20v-6h6" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
    <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
  </>,
  cpu: <>
    <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
    <rect x="9" y="9" width="6" height="6" />
    <path d="M9 1v3" />
    <path d="M15 1v3" />
    <path d="M9 20v3" />
    <path d="M15 20v3" />
    <path d="M20 9h3" />
    <path d="M20 14h3" />
    <path d="M1 9h3" />
    <path d="M1 14h3" />
  </>,
  globe: <>
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </>,
  chart: <>
    <path d="M12 20V10" />
    <path d="M18 20V4" />
    <path d="M6 20v-4" />
  </>,
};

export function PotsIcon({ name }: { name: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      style={{ width: "24px", height: "24px" }}
    >
      {ICON_PATHS[name] ?? null}
    </svg>
  );
}

export function LineIcon({ name }: { name: string }) {
  return (
    <span class="line-icon" aria-hidden="true">
      <PotsIcon name={name} />
    </span>
  );
}

export function PotsAlertBar(props: { children: JSX.Element }) {
  return (
    <div class="pots-alert-bar">
      <div class="pots-alert-bar-inner">
        {props.children}
      </div>
    </div>
  );
}

export function PotsEyebrow(props: { children: string }) {
  return <div class="pots-eyebrow">{props.children}</div>;
}

export function PotsHero(props: {
  title: string;
  description: string;
  ctaText: string;
  ctaHref: string;
  ctaSubtext?: string;
  secondaryCtaText?: string;
  secondaryCtaHref?: string;
}) {
  return (
    <section class="pots-hero-section">
      <div class="pots-hero-content">
        <h1 class="pots-hero-title">{props.title}</h1>
        <p class="pots-hero-desc">{props.description}</p>
        <div class="pots-hero-ctas">
          <a href={props.ctaHref} class="pots-hero-cta-primary">{props.ctaText}</a>
          {props.secondaryCtaText && props.secondaryCtaHref && (
            <a href={props.secondaryCtaHref} class="pots-hero-cta-secondary">{props.secondaryCtaText}</a>
          )}
        </div>
        {props.ctaSubtext && <p class="pots-hero-cta-subtext">{props.ctaSubtext}</p>}
      </div>
    </section>
  );
}

export function PotsContentSplit(props: { children: JSX.Element }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "60px", alignItems: "center" }} class="pots-content-split">
      {props.children}
    </div>
  );
}

export function PotsSystemTags(props: { children: JSX.Element }) {
  return <div class="pots-system-tags">{props.children}</div>;
}

export function PotsSystemTag(props: { icon: string; text: string; alert?: boolean }) {
  return (
    <span class={`pots-system-tag ${props.alert ? "alert" : ""}`}>
      <span>{props.icon}</span>
      {props.text}
    </span>
  );
}

export function PotsCards(props: { children: JSX.Element }) {
  return <div class="pots-cards">{props.children}</div>;
}

export function PotsCard(props: { icon: string; title: string; description: string; href?: string }) {
  const content = (
    <>
      <div class="pots-card-icon">
        <PotsIcon name={props.icon} />
      </div>
      <div class="pots-card-title">{props.title}</div>
      <div class="pots-card-desc">{props.description}</div>
    </>
  );

  if (props.href) {
    return (
      <a class="pots-card pots-card-link" href={props.href}>
        {content}
      </a>
    );
  }

  return <div class="pots-card">{content}</div>;
}

export function PotsFramework(props: { framework: string; children: JSX.Element }) {
  const steps = props.framework.split(".").map((s) => s.trim()).filter(Boolean);
  return (
    <div class="pots-framework">
      <div class="pots-framework-steps">
        {steps.map((step, i) => (
          <>
            <div class="pots-framework-step">
              <span class="pots-framework-num">{i + 1}</span>
              <span class="pots-framework-label">{step}</span>
            </div>
            {i < steps.length - 1 && <div class="pots-framework-arrow">→</div>}
          </>
        ))}
      </div>
      <div class="pots-framework-bullets">
        {props.children}
      </div>
    </div>
  );
}

export function PotsCallout(props: { children: JSX.Element; variant?: "default" | "accent" }) {
  return (
    <div class={`pots-callout ${props.variant ?? "default"}`}>
      {props.children}
    </div>
  );
}

export function PotsStepsSection(props: { title: string; description: string; children: JSX.Element; ctaText: string; ctaHref: string }) {
  return (
    <div class="pots-steps-section">
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}>
        <div class="pots-steps-container">
          <div class="pots-steps-info">
            <h2>{props.title}</h2>
            <p style={{ marginBottom: "32px" }}>{props.description}</p>
            <a href={props.ctaHref} class="cta-button-themed">
              {props.ctaText}
            </a>
          </div>
          <div class="pots-steps-list">{props.children}</div>
        </div>
      </div>
    </div>
  );
}

export function PotsStep(props: { number: number; title: string; description: string }) {
  return (
    <div class="pots-step">
      <div class="pots-step-number">{props.number}</div>
      <div class="pots-step-content">
        <div class="pots-step-title">{props.title}</div>
        <div class="pots-step-desc">{props.description}</div>
      </div>
    </div>
  );
}

export function PotsQuote(props: { text: string }) {
  return (
    <Section>
      <div class="pots-quote">
        <div class="pots-quote-text">{props.text}</div>
      </div>
    </Section>
  );
}
